function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#3C445A"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.538 0c.935 0 1.693.758 1.693 1.692v11.29a5.044 5.044 0 0 0-1.015-.245V1.692a.677.677 0 0 0-.678-.677H1.692a.677.677 0 0 0-.677.677v15.231c0 .374.303.677.677.677h6.772a5.17 5.17 0 0 0 .068 1.015h-6.84A1.692 1.692 0 0 1 0 16.923V1.693C0 .757.758 0 1.692 0h11.846z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.231,
  height: 1.015,
  x: 3.385,
  y: 5.077,
  rx: 0.508
}), /*#__PURE__*/React.createElement("rect", {
  width: 5.923,
  height: 1.015,
  x: 5.923,
  y: 5.077,
  rx: 0.508
}), /*#__PURE__*/React.createElement("rect", {
  width: 5.077,
  height: 1.015,
  x: 3.385,
  y: 8.462,
  rx: 0.508
}), /*#__PURE__*/React.createElement("rect", {
  width: 5.923,
  height: 1.015,
  x: 5.923,
  y: 8.462,
  rx: 0.508
}), /*#__PURE__*/React.createElement("rect", {
  width: 5.077,
  height: 1.015,
  x: 3.385,
  y: 11.846,
  rx: 0.508
}), /*#__PURE__*/React.createElement("rect", {
  width: 5.923,
  height: 1.015,
  x: 5.923,
  y: 11.846,
  rx: 0.508
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.308 13.538)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 4.231,
  cy: 4.231,
  r: 4.231,
  stroke: "#3C445A",
  strokeWidth: 0.8
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3C445A",
  d: "M5.754 3.862a.37.37 0 1 1 0 .738H4.6v1.154a.37.37 0 1 1-.738 0V4.6H2.708a.37.37 0 1 1 0-.738h1.154V2.708a.37.37 0 1 1 .738 0v1.154h1.154z"
})));

var SvgNewProject = function SvgNewProject(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewProject, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new-project.04a915ee.svg";
export { ForwardRef as ReactComponent };